import { render } from "./OlvideMiContra.vue?vue&type=template&id=50b13ce6"
import script from "./OlvideMiContra.vue?vue&type=script&lang=js"
export * from "./OlvideMiContra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__